<template>
  <RfPromptView :key="route.params?.pid" />
</template>

<script setup>
import RfPromptView from "@/views/RfPrompt/RfPromptView.vue";
import { useRoute } from "vue-router";

const route = useRoute();
</script>
